import { USER_PROFILE_UPDATED_EVENT, USER_STORAGE_KEY } from '@/lib/authStorage';
import type { User } from '@/types/auth';

const DEMO_QUERY_PARAM = 'demo';

export const DEMO_MODE_STORAGE_KEY = 'caloriescience_demo_mode';
export const DEMO_MODE_EVENT = 'caloriescience:demo-mode';

export const isDemoModeEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return import.meta.env.VITE_DEMO_MODE === 'true';
  }

  const params = new URLSearchParams(window.location.search);
  const paramValue = params.get(DEMO_QUERY_PARAM)?.toLowerCase();
  if (paramValue === 'true' || paramValue === '1') return true;
  if (paramValue === 'false' || paramValue === '0') return false;

  return (
    import.meta.env.VITE_DEMO_MODE === 'true' ||
    window.sessionStorage.getItem(DEMO_MODE_STORAGE_KEY) === 'true'
  );
};

export const getDemoUser = (): User & { token: string } => ({
  id: 'demo-nutritionist',
  schemaVersion: 1,
  email: 'demo@caloriescience.ai',
  fullName: 'Dr. Maya Bennett',
  phone: '+44 7700 900123',
  phoneCountryCode: '+44',
  role: 'nutritionist',
  roles: ['nutritionist'],
  preferredMeasurementSystem: 'metric',
  qualification: 'Registered Nutritionist',
  experienceYears: 8,
  specialization: ['Weight management', 'Diabetes care', 'Sports nutrition'],
  currency: 'GBP',
  country: 'GB',
  practiceName: 'Harbour Nutrition Clinic',
  practiceAddress: '24 Queen Street, London',
  timezone: 'Europe/London',
  token: 'demo-token.frontend-only.mock',
  createdAt: '2026-01-01T09:00:00.000Z',
  updatedAt: new Date().toISOString(),
});

export const bootstrapDemoMode = () => {
  if (!isDemoModeEnabled() || typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.setItem(DEMO_MODE_STORAGE_KEY, 'true');
  if (!window.localStorage.getItem('caloriescience_cookie_consent')) {
    window.localStorage.setItem(
      'caloriescience_cookie_consent',
      JSON.stringify({
        necessary: true,
        analytics: false,
        version: 1,
        updatedAt: new Date().toISOString(),
      }),
    );
  }
  window.localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(getDemoUser()));
  window.dispatchEvent(new CustomEvent(USER_PROFILE_UPDATED_EVENT));
  window.dispatchEvent(new CustomEvent(DEMO_MODE_EVENT, { detail: { enabled: true } }));
};

export const disableDemoMode = (redirectPath?: string) => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(DEMO_MODE_STORAGE_KEY);
  window.sessionStorage.removeItem('caloriescience_demo_tour_intro_seen');
  try {
    const stored = window.localStorage.getItem(USER_STORAGE_KEY);
    const parsed = stored ? JSON.parse(stored) as { token?: unknown } : null;
    if (parsed?.token === 'demo-token.frontend-only.mock') {
      window.localStorage.removeItem(USER_STORAGE_KEY);
    }
  } catch {
    window.localStorage.removeItem(USER_STORAGE_KEY);
  }
  if (redirectPath) {
    window.location.href = redirectPath;
    return;
  }
  const url = new URL(window.location.href);
  url.searchParams.delete(DEMO_QUERY_PARAM);
  window.location.href = url.toString();
};
